import type { ActivityModule } from '../../core/activity';
import { mountDrawNumbers } from './ui';
import levelsData from './levels.json';
import './style.css';

export const drawNumbers: ActivityModule = {
  id: 'drawnumbers',
  title: 'Desenhe os números',
  description: 'Ligue os pontos em ordem pra desenhar os números de 0 a 9.',
  ageMin: 4,
  ageMax: 6,
  difficulty: 1,
  iconPath: 'assets/gcompris-AGPL/drawnumbers/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountDrawNumbers,
};
